import React from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setErrorCorrectionLevel } from "../../../../../../redux/slices/qrOptions";
import H from "./img/H.png";
import L from "./img/L.png";
import M from "./img/M.png";
import Q from "./img/Q.png";
import classNames from "classnames";

const ErrorLevel = () => {
  const { errorCorrectionLevel, lang } = useSelector((state) => ({
    errorCorrectionLevel: state.qrOptions.errorCorrectionLevel,
    lang: state.changeLang.language.stepThree.errorLevel,
  }));

  const dispatch = useDispatch();

  const levels = {
    L: {
      img: L,
      title: lang[3],
      desc: lang[7],
    },
    M: {
      img: M,
      title: lang[4],
      desc: lang[8],
    },
    Q: {
      img: Q,
      title: lang[5],
      desc: lang[9],
    },
    H: {
      img: H,
      title: lang[6],
      desc: lang[10],
    },
  };

  return (
    <>
      <Row className="fs-5 text-capitalize g-0 mb-3">
        <Col xs="auto">
          <div className="fw-bold me-1">{lang[0]}</div>
        </Col>
        <Col xs="auto mb-1">
          <div>{lang[1]}</div>
        </Col>
        <div className="text-gray fs-7 mb-2" style={{ textTransform: "none" }}>
          {lang[2]}
        </div>
      </Row>

      <Row className="g-4">
        {Object.entries(levels)
          .reverse()
          .map(([key, value]) => (
            <Col key={key} xs={6} md={3}>
              <div
                className={classNames(
                  "border rounded p-4 h-100 overflow-hidden",
                  {
                    "border-primary": errorCorrectionLevel === key,
                    "border-border-gray": errorCorrectionLevel !== key,
                  }
                )}
                onClick={() => dispatch(setErrorCorrectionLevel(key))}
              >
                <img
                  loading="lazy"
                  src={value.img}
                  alt="key-error-level"
                  className="img-fluid w-100"
                />
                <div className="fw-bold mt-2">{value.title}</div>
                <div
                  className="text-gray fs-7 mt-1"
                  style={{ textTransform: "none" }}
                >
                  {value.desc}
                </div>
              </div>
            </Col>
          ))}
      </Row>
    </>
  );
};

export default ErrorLevel;
